<template>
  <div v-if="!isNarrowWidthDevice" class="fixed-header">
    <div class="container">
      <div class="title-container">
        <h1>{{ header || '' }}</h1>
      </div>
      <div v-if="!isHideSearchbox" class="search-box-wrapper">
        <SearchBoxInHeader :showInfo="false"></SearchBoxInHeader>
      </div>
      <div
        v-if="isExtraLargeWidthDevice"
        class="language"
        :class="{ 'home-page': $route.name === 'home' }"
      >
        <div
          class="language__switch"
          @click="toggleLanguageDropdown"
          v-click-outside="onClickOutside"
        >
          <fa class="pr-8" icon="globe-asia"></fa>
          <span class="pr-16">{{ currentLanguage.name }}</span>
          <fa
            icon="chevron-down"
            :class="{ 'fa-rotate-180': isShowLanguageDropdown }"
          ></fa>
        </div>
        <div v-if="isShowLanguageDropdown" class="language_dropdown">
          <a
            class="dropdown-item lang_menu"
            v-for="lang of selectableLanguages"
            :key="lang.locale"
            @click="changeLocale(lang)"
          >
            {{ lang.name }}
          </a>
        </div>
      </div>
      <div
        v-else
        class="language language--mobile"
        :class="{ 'home-page': $route.name === 'home' }"
      >
        <div
          class="language__switch"
          @click="toggleLanguageDropdown"
          v-click-outside="onClickOutside"
        >
          <fa class="pr-8" icon="globe-asia"></fa>
          <fa
            icon="chevron-down"
            :class="{ 'fa-rotate-180': isShowLanguageDropdown }"
          ></fa>
        </div>
        <div v-if="isShowLanguageDropdown" class="language_dropdown">
          <a
            class="dropdown-item lang_menu"
            v-for="lang of selectableLanguages"
            :key="lang.locale"
            @click="changeLocale(lang)"
          >
            {{ lang.name }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="fixed-header mobile" :style="{ top: styleTopValue }">
    <div class="title-container">
      <h4 class="title-mobile">
        <span class="title-mobile__left">NetOX</span>
        <span class="title-mobile__right">{{ header || 'Header' }}</span>
      </h4>
      <div class="tool">
        <div class="language" :class="{ 'home-page': $route.name === 'home' }">
          <div
            class="language__switch"
            @click="toggleLanguageDropdown"
            v-click-outside="onClickOutside"
          >
            <fa class="pr-8" icon="globe-asia"></fa>
            <fa
              icon="chevron-down"
              :class="{ 'fa-rotate-180': isShowLanguageDropdown }"
            ></fa>
          </div>
          <div v-if="isShowLanguageDropdown" class="language_dropdown">
            <a
              class="dropdown-item lang_menu"
              v-for="lang of selectableLanguages"
              :key="lang.locale"
              @click="changeLocale(lang)"
            >
              {{ lang.name }}
            </a>
          </div>
        </div>
        <div class="sidebar-switch" @click="showSidebar">
          <fa icon="bars"></fa>
        </div>
      </div>
    </div>
    <div v-if="!isHideSearchbox" class="search-box-wrapper">
      <SearchBoxInHeader :showInfo="false"></SearchBoxInHeader>
    </div>
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside';
import { mapMutations, mapState } from 'vuex';
import i18n from '../../i18n';
import SearchBoxInHeader from '../SearchBoxInHeader.vue';
import languageConfig from '../../config/language';

export default {
  components: { SearchBoxInHeader },
  props: ['header', 'topOnMobile'],
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      languages: languageConfig.options,
      currentLanguage: { name: 'English', locale: 'en' },
      isShowLanguageDropdown: false,
    };
  },
  computed: {
    ...mapState(['isNarrowWidthDevice', 'isExtraLargeWidthDevice']),
    selectableLanguages() {
      return this.languages.filter(
        (i) => i.locale !== this.currentLanguage.locale
      );
    },
    isHideSearchbox() {
      return this.$route && this.$route.path.includes('/apnic-comparison');
    },
    styleTopValue() {
      if (!this.isNarrowWidthDevice) return '40px';
      return `${this.topOnMobile}px`;
    },
  },

  mounted() {
    const initialLanguage = languageConfig.init();

    if (initialLanguage) this.currentLanguage = initialLanguage;
  },
  methods: {
    ...mapMutations(['setIsShowSidebarOnMobile']),

    changeLocale(lang) {
      // Trigger Event for GTM to track the selected language
      window.dataLayer.push({
        event: 'selected-language',
        selectedLanguage: lang.locale,
      });

      this.currentLanguage = lang;
      localStorage.setItem('lang', JSON.stringify(lang));
      i18n.locale = lang.locale;
      window.changeLocale(i18n.locale);
      this.isShowLanguageDropdown = false;
      location.reload();
    },
    toggleLanguageDropdown() {
      this.isShowLanguageDropdown = !this.isShowLanguageDropdown;
    },
    onClickOutside() {
      setTimeout(() => {
        this.isShowLanguageDropdown = false;
      }, 200);
    },
    showSidebar() {
      this.setIsShowSidebarOnMobile(true);
    },
  },
};
</script>

<style lang="scss">
.fixed-header {
  height: 60px;
  position: sticky;
  position: -webkit-sticky; /* Safari */
  left: 0;
  top: 40px;
  background: #fff;
  z-index: 1002;
  transition: width 0.5s;

  &.opacity {
    opacity: 0.9;
  }

  &:hover {
    opacity: 1;
  }

  & > .container {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .sidebar-toggle {
    position: absolute;
    top: 8px;
    left: 6px;
  }

  h1 {
    height: 60px;
    margin: 0;
    line-height: 60px;
    font-size: 1.5rem;
    color: $text-black;
    white-space: nowrap;

    @media screen and (max-width: 485px) {
      font-size: 22px;
    }
  }

  .search-box-wrapper {
    flex: 0 0 auto;
    height: 48px;
  }

  .language {
    height: 48px;
    border: 1px solid $text-black;
    color: $text-black;

    .language__switch {
      width: 8rem;
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }

    .language_dropdown {
      width: 8rem;
      background-color: #ccc;
      cursor: pointer;

      .lang_menu {
        color: $text-black;
        height: 3rem;
        line-height: 3rem;
        padding: 0;
        text-align: center;

        &:hover {
          color: white;
          background-color: #666;
        }
      }
    }
  }

  .language--mobile {
    position: relative;
    border: none;

    .language__switch {
      width: 3rem;
    }

    .language_dropdown {
      position: absolute;
      right: 0;
      z-index: 1;
      width: 6rem;
    }
  }

  .dropdown {
    @media screen and (max-width: 768px) {
      display: block !important;
    }

    &.home-page {
      @media screen and (max-width: 768px) {
        display: table;
      }
    }
  }
}

@media screen and (max-width: 940px) {
  .fixed-header {
    height: auto;

    & > .container {
      flex-wrap: wrap;
    }

    .search-box-wrapper {
      order: 2;
      padding: 0rem;
      padding-right: 12rem;
      margin-bottom: 0.5rem;
    }
  }
}

.mobile.fixed-header {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  height: auto;
  top: 0;
  padding: 0 1rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.5s;

  .title-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h4 {
      display: flex;
      align-items: center;
      margin: 0;

      span {
        margin-right: 0.5rem;
        color: #333333;
        font-size: 1.5rem;
      }

      span:nth-child(2) {
        padding-left: 0.5rem;
        border-left: 2px solid $apnic-blue;
        font-size: 1rem;
      }
    }

    .tool {
      display: flex;
    }

    .sidebar-switch {
      width: 3rem;
      height: 3rem;
      line-height: 3rem;
      text-align: center;
      cursor: pointer;

      svg {
        font-size: 1.2rem;
      }
    }

    .language {
      position: relative;
      border: none;

      .language__switch {
        width: 3rem;
      }

      .language_dropdown {
        position: absolute;
        z-index: 1;
        width: 6rem;
      }
    }
  }

  .search-box-wrapper {
    padding: 0;
    margin-bottom: 0.5rem;
  }
}
</style>
